import { Component, OnInit } from "@angular/core";
import { Product } from "../../../shared/classes/product";
import {
  Article,
  ArticleFilter,
  FilterContainer,
} from "../../../shared/models/article";
import { Customer } from "../../../shared/models/customer";
import { ArticleService } from "../../../shared/services/article.service";
import { ActivatedRoute, Params } from "@angular/router";
import { UserService } from "../../../shared/services/user.service";
import { PreferenceService } from "../../../shared/services/preference.service";

@Component({
  selector: "app-search",
  templateUrl: "./search.component.html",
  styleUrls: ["./search.component.css"],
})
export class SearchComponent implements OnInit {
  public products: Product[] = [];
  public articles: Article[] = [];
  departmentId: number = null;
  loading: boolean;
  pages: number;
  customer: Customer;

  filter: FilterContainer = {
    article: new Article(),
    departmentId: null,
    page: 1,
  };
  constructor(
    private articleService: ArticleService,
    private activatedRoute: ActivatedRoute,
    private userService: UserService,
    public preferenceService: PreferenceService
  ) {
    this.loading = true;
  }

  ngOnInit() {
    this.activatedRoute.params.forEach((params: Params) => {
      this.customer = this.userService.getIdentity();
      this.filter.article.name = params.article;
      this.getProducts();
    });
  }

  getProducts = () => {
    this.loading = true;
    const article: Article = new Article();
    article.name = this.filter.article.name || "";
    article.departmentId = null;
    article.fromClient = true;
    this.articleService.getArticles(this.filter.page, article).subscribe(
      (res) => {
        this.loading = true;
        this.articles = res.rows;
        this.pages = res.pagination.pages;
        this.loading = false;
      },
      (error) => {
        console.error(<any>error);
      }
    );
  };

  onPrev = (): void => {
    this.loading = true;
    this.filter.page = this.filter.page - 1;
    this.getProducts();
  };

  onNext(): void {
    this.loading = true;
    this.filter.page = this.filter.page + 1;
    this.getProducts();
  }
}
